module.exports = __webpack_public_path__ + "img/loginBg.7b44fc59.jpg";